export default __webpack_public_path__ + "static/media/ic_choose_from_computer.33e5cd5e.svg";